import { gql } from '@apollo/client';

export const FETCH_ENTITY_NAME = gql`
  query fetchUserEntityName($userId: SafeString!) {
    fetchUser(input: { userId: $userId }) {
      user {
        id: stringId
        entityName
      }
    }
  }
`;
